import { Progress } from "@verde/ui-core";
import React from "react";
import { tv } from "tailwind-variants";
import { useCreditProfilePanel } from "./panel";
import PanelData from "./panel-data";
import PanelHeading from "./panel-heading";
import PanelNavigation from "./panel-navigation";
import PanelStatus from "./panel-status";

const styles = tv({
  slots: {
    content: "grid gap-2 rounded-b bg-neutral-light-1 px-6 py-4",
  },
  variants: {
    anchor: {
      true: {
        content: "p-0",
      },
    },
  },
});

function PanelHasClient() {
  const { mode, updating, resource, dispatchCreditsUsage } =
    useCreditProfilePanel();

  return (
    <div>
      <PanelHeading
        onRefresh={() => {
          dispatchCreditsUsage({
            type: "refresh",
          });
        }}
      />

      <div
        className={styles().content({
          anchor: mode === "anchor",
        })}
      >
        {mode !== "anchor" && <PanelNavigation />}

        <PanelStatus />

        {mode !== "anchor" && !updating && resource.available === true && (
          <PanelData />
        )}
        {mode !== "anchor" && updating && resource.available === true && (
          <div className="grid gap-6 rounded border border-neutral-light-2 bg-neutral-light-pure p-6">
            <div className="grid gap-1">
              <p className="text-lg font-semibold">Recalculando dados...</p>
              <p className="font-medium">Isso pode levar alguns minutos...</p>
            </div>

            <Progress kind="infinite" />
          </div>
        )}
      </div>
    </div>
  );
}

export default React.memo(PanelHasClient);
